import { Record } from "@common/data-models/records/record";
import { CollectionRecord } from '@common/data-models/records/collection-record'
import { EnpsSubscriber } from '@common/utils/enps-subscriber';
import { Subscription, Subject } from 'rxjs';

export class TileColumn extends EnpsSubscriber {
    public changesSub: Subscription = new Subscription();
    public resetCostSubject = new Subject<void>();

    public value: string;

    constructor(
        public name?: string,
        public displayName?: string,
        public tiles?: Array<Record>,
        public dateDisplayName?: string,
        public day?: number
    ) {
        super();
    }

    public registerTiles() {
        if (this.changesSub) this.changesSub.unsubscribe();
        this.changesSub = new Subscription();
        this.tiles.forEach((item) => {
            let tmpSub = super.createSubscription(item.changeObserver, () => {
                this.registerTiles();
                this.resetCostSubject.next();
            });
            if (item.isCollection) {
                let children = (<CollectionRecord>item).getChildren();
                for (let child of children) {
                    let assignmentSub = super.createSubscription(child.changeObserver, () => {
                        this.resetCostSubject.next();
                    });
                    this.changesSub.add(assignmentSub);
                }
            }
            this.changesSub.add(tmpSub);
        });
        this.resetCostSubject.next();
    }

    public unRegisterTiles() {
        super.removeAllSubscriptions();
        this.resetCostSubject.next();
    }
}
